import {AbstractEntity} from "../abstract-entity.model";
import {SimpleEntity} from "../simple-entity.model";
import { WhTransferOrderProductModel } from "./wh-transfer-order-product.model";

export class WhTransferOrderModel extends AbstractEntity{
  warehouse: SimpleEntity;
  newWarehouse: SimpleEntity;
  branch: SimpleEntity;
  details: WhTransferOrderProductModel[] = [];
}
